import { Component, OnInit } from '@angular/core';

import { ActivationEnd } from "@angular/router/src/events";
import { MessagingService } from '../../services/messaging.service';
import { Message } from '../../models/message';


@Component({
  selector: 'contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {


  message: Message = {
    sendFrom: {},
    sendTo: "",
    title: "",
    body: "",
    active: true,
    archived: false
  };

  contactEmail: string = '';
  contactName: string = '';
  userObject: object;
  destroyForm: boolean = true;

  _ref: any;


  constructor(
    private messagingService: MessagingService) { }

  ngOnInit() {
    this.message.sendTo = 'Hz6NkEhA7HeQbYv1D9cF1nJW9qg1';
  }

  sendMessage(message) {
    console.log(message);
    message.sendFrom.userName = 'CONTACT FORM';
    message.sendFrom.userEmail = this.contactEmail;
    this.messagingService.sendMessage(message);
    this.message.title = '';
    this.message.body = '';
    this.destroyForm = false;
  }

  validationForm() {
    if (this.message.title !== "" && this.message.body !== "" && this.contactEmail !== '') {
      return true;
    } else {
      return false;
    }
  }


}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/contactus/contactus.component.ts